// authService.jsx
import axios from "axios";

const REGISTER_URL = "/api/v1/auth/users/";
const LOGIN_URL = "/api/v1/auth/jwt/create/";
const ACTIVATE_URL = "/api/v1/auth/users/activation/";


// Register user
const register = async (userData) => {
	try {
		const config = {
			headers: {
				"Content-Type": "application/json",
			},
		};

		const response = await axios.post(REGISTER_URL, userData, config);
		return response.data;
	} catch (error) {
		// Handle registration error
		console.error("Registration error:", error);
		throw error; // Rethrow the error to propagate it to the caller
  	}
};

// Login user

const login = async (userData) => {
	try {
		const config = {
			headers: {
				"Content-Type": "application/json",
			},
		};
		const response = await axios.post(LOGIN_URL, userData, config);
		if (response.data) {
			localStorage.setItem("user", JSON.stringify(response.data));
		}
		return response.data;
	} catch (error) {
		// Handle login error
		console.error("Login error:", error);
		throw error; // Rethrow the error to propagate it to the caller
  	}
};

// Logout user
const logout = () => {
	localStorage.removeItem("user");
};


// activate a User
const activate = async (userData) => {
	try {
		const config = {
			headers: {
				"Content-Type": "application/json",
			},
		};
		const response = await axios.post(ACTIVATE_URL, userData, config);
		return response.data;
	} catch (error) {
		// Handle activation error
		console.error("Activation error:", error);
		throw error; // Rethrow the error to propagate it to the caller
  	}
};

const authService = { register, login, logout, activate };

export default authService;